import { ISpecificUsers, PostVisibilityEnum } from 'redux-store/api/activity-feed';

export type TConvertedAudience = { postVisibility: PostVisibilityEnum } & ISpecificUsers;

export interface TransformedAudience {
  visibility: number[];
  postVisibility?: PostVisibilityEnum;
  audienceRoles?: number[];
  audienceGroups?: number[];
  visibleProfileIds?: number[];
}

export const enum SourceEnum {
  BY_ROLE = 'byRole',
  CUSTOM_GROUPS = 'customGroups',
}

export type TSourcedSpecificUser = ISpecificUsers['byRole'][number] & {
  source: SourceEnum;
};

export type TSelectedSourcedSpecificUser = TSourcedSpecificUser & { isSelected: boolean };

export interface ISourcedProjectAudiences {
  byRole: TSourcedSpecificUser[];
  customGroups: TSourcedSpecificUser[];
}

export interface IAudienceMembers {
  title: string;
  isEveryone?: boolean;
  members: {
    avatar: string;
    firstName: string;
    lastName: string;
    id: number;
  }[];
}
